import useStyles from "_styles/molecules/pinnedComment";

import ChatEmotes from "./chatEmote";

const component = props => {
	const {
		pinnedCommentData,
		toggleReadMore,
		isReadMore,
		emotesList
	} = props;

	const { classes } = useStyles ();

	if ( pinnedCommentData.donationProductUrl )
		return null;

	return (
		<>
			<span className = { classes.comment }>
				{" "}

				<ChatEmotes
					emotesList = { emotesList }
					isReadMore = { isReadMore }
					text       = { !isReadMore ? pinnedCommentData.commentText : pinnedCommentData.commentText.substring ( 0, 90 ) }
				/>

			</span>

			{
				pinnedCommentData?.commentText?.length > 60 ? (
					<span className = { classes.readOrHide }
						onClick        = { toggleReadMore }
					>
						{isReadMore ? "...show more" : " show less"}
					</span>
				) : null
			}
		</>
	);
};

export default component;
